/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

/** VendorBillStatus */
export enum VendorBillStatus {
  Draft = 'draft',
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Withdrawn = 'withdrawn',
}

/** VendorBillSourceType */
export enum VendorBillSourceType {
  WorkOrder = 'workOrder',
}

/** TransactionType */
export enum TransactionType {
  Payment = 'payment',
  Return = 'return',
  Refund = 'refund',
  Dispute = 'dispute',
  Credit = 'credit',
  Transfer = 'transfer',
}

/** TransactionStatus */
export enum TransactionStatus {
  Pending = 'pending',
  Failed = 'failed',
  Success = 'success',
  Cancelled = 'cancelled',
  Returned = 'returned',
  Refunded = 'refunded',
  Disputing = 'disputing',
  Disputed = 'disputed',
}

/** TransactionPaymentMethod */
export enum TransactionPaymentMethod {
  Ach = 'ach',
  DebitCard = 'debitCard',
  Wallet = 'wallet',
  CreditCard = 'creditCard',
  Check = 'check',
  CashiersCheck = 'cashiersCheck',
  MoneyOrder = 'moneyOrder',
  Cash = 'cash',
  Zelle = 'zelle',
  Other = 'other',
  Credit = 'credit',
  Transfer = 'transfer',
}

/** TransactionIdentity */
export enum TransactionIdentity {
  LeaseCharge = 'leaseCharge',
  LeaseDeposit = 'leaseDeposit',
  LeaseProcessingFee = 'leaseProcessingFee',
  RentalApplicationFee = 'rentalApplicationFee',
  PropertyCharge = 'propertyCharge',
  OwnerContribution = 'ownerContribution',
  OwnerDistribution = 'ownerDistribution',
  ManagementFee = 'managementFee',
  ServiceBill = 'serviceBill',
  VendorBill = 'vendorBill',
  CompanyDisbursement = 'companyDisbursement',
  MagicDoorBill = 'magicDoorBill',
  BankLedgerTransfer = 'bankLedgerTransfer',
}

/** TransactionDirection */
export enum TransactionDirection {
  In = 'in',
  Out = 'out',
}

/** ReportType */
export enum ReportType {
  Property = 'property',
  Company = 'company',
}

/** ReconciliationReviewReason */
export enum ReconciliationReviewReason {
  SourceModifiedAfterResolution = 'sourceModifiedAfterResolution',
  SourceRemovedAfterResolution = 'sourceRemovedAfterResolution',
  AccountingTargetChangedAfterResolution = 'accountingTargetChangedAfterResolution',
}

/** ReconciliationResolutionType */
export enum ReconciliationResolutionType {
  Matched = 'matched',
  Settled = 'settled',
  Posted = 'posted',
  Ignored = 'ignored',
}

/** ReconciliationPeriodStatus */
export enum ReconciliationPeriodStatus {
  Draft = 'draft',
  Reopened = 'reopened',
  Locked = 'locked',
}

/** ReconciliationPeriodReadStatus */
export enum ReconciliationPeriodReadStatus {
  Valid = 'valid',
  Invalidated = 'invalidated',
  Impacted = 'impacted',
}

/** ReconciliationPeriodItemsSource */
export enum ReconciliationPeriodItemsSource {
  Live = 'live',
  LockedSnapshot = 'lockedSnapshot',
}

/** ReconciliationPeriodInvalidationReason */
export enum ReconciliationPeriodInvalidationReason {
  SourceModifiedAfterLock = 'sourceModifiedAfterLock',
  SourceRemovedAfterLock = 'sourceRemovedAfterLock',
  EntryPostedAfterLock = 'entryPostedAfterLock',
  AccountingTargetChangedAfterLock = 'accountingTargetChangedAfterLock',
}

/** ReconciliationPeriodDispositionStatus */
export enum ReconciliationPeriodDispositionStatus {
  Open = 'open',
  Acknowledged = 'acknowledged',
}

/** ReconciliationPeriodBlockerType */
export enum ReconciliationPeriodBlockerType {
  PeriodStatus = 'periodStatus',
  SubsequentPeriodNotReopened = 'subsequentPeriodNotReopened',
  EarlierEditablePeriod = 'earlierEditablePeriod',
  UnresolvedBankFeedEntry = 'unresolvedBankFeedEntry',
  DuplicateReconciliationItems = 'duplicateReconciliationItems',
  MissingReconciliationItemResolution = 'missingReconciliationItemResolution',
  OpenReconciliationItemReview = 'openReconciliationItemReview',
  ReconciliationItemAlreadyLocked = 'reconciliationItemAlreadyLocked',
  MissingReconciliationItemTransactionLinks = 'missingReconciliationItemTransactionLinks',
  DuplicateReconciliationItemTransactionLinks = 'duplicateReconciliationItemTransactionLinks',
  OpenPeriodDisposition = 'openPeriodDisposition',
  BalanceDifference = 'balanceDifference',
  DraftPeriod = 'draftPeriod',
}

/** ReconciliationPeriodAction */
export enum ReconciliationPeriodAction {
  Edit = 'edit',
  Delete = 'delete',
  Lock = 'lock',
  Reopen = 'reopen',
}

/** ReconciliationItemStatus */
export enum ReconciliationItemStatus {
  Open = 'open',
  NeedsReview = 'needsReview',
  Completed = 'completed',
}

/** ReconciliationItemActionBlocker */
export enum ReconciliationItemActionBlocker {
  LockedPeriod = 'lockedPeriod',
  EntryRetracted = 'entryRetracted',
  EntryNotFound = 'entryNotFound',
  EntryIsInflow = 'entryIsInflow',
}

/** ReconciliationIgnoreReason */
export enum ReconciliationIgnoreReason {
  SourceRemoved = 'sourceRemoved',
  BankAccountDeleted = 'bankAccountDeleted',
  Duplicate = 'duplicate',
  AlreadyRecorded = 'alreadyRecorded',
  OutsideManagedScope = 'outsideManagedScope',
  WrongBankAccount = 'wrongBankAccount',
  NotBusinessRelated = 'notBusinessRelated',
  BelongsToAnotherEntity = 'belongsToAnotherEntity',
  OpeningBalanceArtifact = 'openingBalanceArtifact',
  VerificationOrTest = 'verificationOrTest',
  Other = 'other',
}

/** ReconciliationCandidateGenerationStatus */
export enum ReconciliationCandidateGenerationStatus {
  Pending = 'pending',
  Ready = 'ready',
  Failed = 'failed',
}

/** PartyType */
export enum PartyType {
  Lease = 'lease',
  Tenant = 'tenant',
  Vendor = 'vendor',
  Owner = 'owner',
  RentalApplication = 'rentalApplication',
  Subsidizer = 'subsidizer',
}

/** OwnerPackageReportType */
export enum OwnerPackageReportType {
  BalanceSheet = 'balanceSheet',
  CashFlowStatement = 'cashFlowStatement',
  IncomeStatement = 'incomeStatement',
  OwnerStatement = 'ownerStatement',
}

/** ManualReconciliationStatus */
export enum ManualReconciliationStatus {
  InProgress = 'inProgress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

/** ManualReconciliationEntryType */
export enum ManualReconciliationEntryType {
  Included = 'included',
  Excluded = 'excluded',
}

/** ManualJournalEntryStatus */
export enum ManualJournalEntryStatus {
  Draft = 'draft',
  PendingApproval = 'pendingApproval',
  Approved = 'approved',
  Posted = 'posted',
  Rejected = 'rejected',
}

/** MagicUserType */
export enum MagicUserType {
  System = 'system',
  MagicDoor = 'magicDoor',
  PropertyManager = 'propertyManager',
  Tenant = 'tenant',
  Vendor = 'vendor',
  Owner = 'owner',
}

/** JournalEntryType */
export enum JournalEntryType {
  VendorBill = 'vendorBill',
  Credit = 'credit',
  ManagementFeeCredit = 'managementFeeCredit',
  OwnerDistribution = 'ownerDistribution',
  OwnerContribution = 'ownerContribution',
  LeaseCharge = 'leaseCharge',
  LateFee = 'lateFee',
  ManualEntry = 'manualEntry',
  LeaseDeposit = 'leaseDeposit',
  LeaseProcessingFee = 'leaseProcessingFee',
  MagicDoorBill = 'magicDoorBill',
  ManagementFee = 'managementFee',
  PropertyBill = 'propertyBill',
  RentalApplicationFee = 'rentalApplicationFee',
  ServiceBill = 'serviceBill',
  Return = 'return',
  LedgerTransfer = 'ledgerTransfer',
  CompanyDisbursement = 'companyDisbursement',
  BankLedgerTransfer = 'bankLedgerTransfer',
  BankLedgerAdjustment = 'bankLedgerAdjustment',
}

/** JournalEntrySourceType */
export enum JournalEntrySourceType {
  Bill = 'bill',
  Transaction = 'transaction',
  DepositRelease = 'depositRelease',
  Manual = 'manual',
  BankLedgerTransfer = 'bankLedgerTransfer',
}

/** ExternalTransactionType */
export enum ExternalTransactionType {
  Plaid = 'plaid',
  Stripe = 'stripe',
  Zelle = 'zelle',
  Offline = 'offline',
  MagicDoor = 'magicDoor',
}

/** CreationSource */
export enum CreationSource {
  None = 'none',
  Direct = 'direct',
  Import = 'import',
  AutoPay = 'autoPay',
  Recurring = 'recurring',
  Public = 'public',
}

/** ChartOfAccountType */
export enum ChartOfAccountType {
  Asset = 'asset',
  Equity = 'equity',
  Liability = 'liability',
  Revenue = 'revenue',
  Expense = 'expense',
  OtherRevenue = 'otherRevenue',
  OtherExpense = 'otherExpense',
}

/** CashFlowGroupBy */
export enum CashFlowGroupBy {
  Total = 'total',
  Property = 'property',
  Year = 'year',
  Quarter = 'quarter',
  Month = 'month',
}

/** BillType */
export enum BillType {
  VendorBill = 'vendorBill',
  LeaseCharge = 'leaseCharge',
  LeaseDeposit = 'leaseDeposit',
  LeaseLateFee = 'leaseLateFee',
  LeaseProcessingFee = 'leaseProcessingFee',
  OwnerContribution = 'ownerContribution',
  OwnerDistribution = 'ownerDistribution',
  OwnerTransfer = 'ownerTransfer',
  ManagementFee = 'managementFee',
  ServiceBill = 'serviceBill',
  PropertyCharge = 'propertyCharge',
  RentalApplicationFee = 'rentalApplicationFee',
  MagicDoorBill = 'magicDoorBill',
  CompanyLedgerTransfer = 'companyLedgerTransfer',
  BankLedgerTransfer = 'bankLedgerTransfer',
  LeaseLedgerTransfer = 'leaseLedgerTransfer',
}

/** BankLedgerTransferType */
export enum BankLedgerTransferType {
  BankToBank = 'bankToBank',
  BankDeposit = 'bankDeposit',
  BankWithdrawal = 'bankWithdrawal',
}

/** BankFeedSourceType */
export enum BankFeedSourceType {
  Plaid = 'plaid',
  Yodlee = 'yodlee',
  Manual = 'manual',
  PdfImport = 'pdfImport',
  CsvImport = 'csvImport',
  OfxImport = 'ofxImport',
  ApiImport = 'apiImport',
}

/** BankFeedEntryStatus */
export enum BankFeedEntryStatus {
  Active = 'active',
  Retracted = 'retracted',
}

/** BankFeedConnectionRefreshBlockerCode */
export enum BankFeedConnectionRefreshBlockerCode {
  RequiresReauthentication = 'requiresReauthentication',
  Disconnected = 'disconnected',
  NoActiveAccounts = 'noActiveAccounts',
  SyncInProgress = 'syncInProgress',
  RecentlyRequested = 'recentlyRequested',
}

/** BankAccountType */
export enum BankAccountType {
  Checking = 'checking',
  Savings = 'savings',
}

/** AccountingBasis */
export enum AccountingBasis {
  Cash = 'cash',
  Accrual = 'accrual',
}

/** ResolveReconciliationItemRequestDto */
export type ResolveReconciliationItemRequestDto = BaseResolveReconciliationItemRequestDto &
  (
    | BaseResolveReconciliationItemRequestDtoTypeMapping<'ResolveReconciliationItemAcceptDto', ResolveReconciliationItemAcceptDto>
    | BaseResolveReconciliationItemRequestDtoTypeMapping<'ResolveReconciliationItemMatchDto', ResolveReconciliationItemMatchDto>
    | BaseResolveReconciliationItemRequestDtoTypeMapping<'ResolveReconciliationItemSettleDto', ResolveReconciliationItemSettleDto>
    | BaseResolveReconciliationItemRequestDtoTypeMapping<'ResolveReconciliationItemPostDto', ResolveReconciliationItemPostDto>
    | BaseResolveReconciliationItemRequestDtoTypeMapping<'ResolveReconciliationItemIgnoreDto', ResolveReconciliationItemIgnoreDto>
  );

/** ReconciliationCandidatePayloadDto */
export type ReconciliationCandidatePayloadDto = BaseReconciliationCandidatePayloadDto &
  (
    | BaseReconciliationCandidatePayloadDtoTypeMapping<
        'BankLedgerTransferReconciliationCandidatePayloadDto',
        BankLedgerTransferReconciliationCandidatePayloadDto
      >
    | BaseReconciliationCandidatePayloadDtoTypeMapping<
        'LeaseChargeReconciliationCandidatePayloadDto',
        LeaseChargeReconciliationCandidatePayloadDto
      >
    | BaseReconciliationCandidatePayloadDtoTypeMapping<
        'LeaseDepositReconciliationCandidatePayloadDto',
        LeaseDepositReconciliationCandidatePayloadDto
      >
    | BaseReconciliationCandidatePayloadDtoTypeMapping<
        'OwnerDistributionReconciliationCandidatePayloadDto',
        OwnerDistributionReconciliationCandidatePayloadDto
      >
    | BaseReconciliationCandidatePayloadDtoTypeMapping<
        'OwnerContributionReconciliationCandidatePayloadDto',
        OwnerContributionReconciliationCandidatePayloadDto
      >
  );

/** ReconciliationCandidateDto */
export type ReconciliationCandidateDto = BaseReconciliationCandidateDto &
  (
    | BaseReconciliationCandidateDtoTypeMapping<'MatchingReconciliationCandidateDto', MatchingReconciliationCandidateDto>
    | BaseReconciliationCandidateDtoTypeMapping<'SettlingReconciliationCandidateDto', SettlingReconciliationCandidateDto>
    | BaseReconciliationCandidateDtoTypeMapping<'PostingReconciliationCandidateDto', PostingReconciliationCandidateDto>
  );

/** AddManualReconciliationEntriesDto */
export interface AddManualReconciliationEntriesDto {
  transactionIds?: string[];
  depositSlipIds?: string[];
  type: ManualReconciliationEntryType;
}

/** AddVendorBillFileDto */
export interface AddVendorBillFileDto {
  uploadSessionId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** AddVendorBillFilesRequestDto */
export interface AddVendorBillFilesRequestDto {
  /** @minItems 1 */
  files: AddVendorBillFileDto[];
}

/** AdjustBankLedgerTransferRequestDto */
export interface AdjustBankLedgerTransferRequestDto {
  /** @format date-time */
  transferDate: string;
  /**
   * @format double
   * @min 0.01
   * @max 999999999.99
   */
  amount: number;
  propertyId?: string;
  paymentMethod?: TransactionPaymentMethod;
  outgoing?: BankLedgerTransferSideDto;
  incoming?: BankLedgerTransferSideDto;
  offsetAccount?: OffsetAccountInfoDto;
  externalTransactionType?: ExternalTransactionType;
  /**
   * @minLength 0
   * @maxLength 200
   */
  externalTransactionId?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  metadata?: Record<string, string>;
}

/** ApproveManualJournalEntryRequestDto */
export interface ApproveManualJournalEntryRequestDto {
  /** @minLength 1 */
  approverId: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  reason?: string;
}

/** BalanceSheetDto */
export interface BalanceSheetDto {
  assets: ReportSectionDto;
  liabilities: ReportSectionDto;
  equity: ReportSectionDto;
}

/** BankAccountDto */
export interface BankAccountDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  name: string;
  description?: string;
  accountNumber?: string;
  routingNumber?: string;
  type?: BankAccountType;
  companyAccount: boolean;
  active: boolean;
  scheduledSweepDays: number[];
  chartOfAccountIds: string[];
  creator: CreatorDto;
}

/** BankAccountsDto */
export interface BankAccountsDto {
  bankAccounts: BankAccountDto[];
}

/** BankFeedAccountMatchResultDto */
export interface BankFeedAccountMatchResultDto {
  providerAccountId: string;
  displayName: string;
  mask?: string;
  type?: string;
  subtype?: string;
  matchStatus: string;
  bankAccountId?: string;
  bankAccountName?: string;
}

/** BankFeedConnectionAccountDto */
export interface BankFeedConnectionAccountDto {
  id?: string;
  providerAccountId: string;
  bankAccountId: string;
  accountName: string;
  mask?: string;
  type: string;
  subtype?: string;
  status: string;
}

/** BankFeedConnectionDetailDto */
export interface BankFeedConnectionDetailDto {
  id: string;
  companyId: string;
  providerConnectionId: string;
  status: string;
  /** @format date-time */
  lastSynced?: string;
  /** @format date-time */
  lastRefreshRequested?: string;
  accounts: BankFeedConnectionAccountDto[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  refreshCapability: BankFeedConnectionRefreshCapabilityDto;
  latestRefreshAttempt?: BankFeedConnectionRefreshAttemptDto;
  latestBankFeedSync?: BankFeedSyncDto;
}

/** BankFeedConnectionDto */
export interface BankFeedConnectionDto {
  id: string;
  companyId: string;
  providerConnectionId: string;
  status: string;
  /** @format date-time */
  lastSynced?: string;
  /** @format date-time */
  lastRefreshRequested?: string;
  accounts: BankFeedConnectionAccountDto[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** BankFeedConnectionListDto */
export interface BankFeedConnectionListDto {
  items: BankFeedConnectionListItemDto[];
}

/** BankFeedConnectionListItemDto */
export interface BankFeedConnectionListItemDto {
  id: string;
  providerConnectionId: string;
  status: string;
  /** @format date-time */
  lastSynced?: string;
  /** @format date-time */
  lastRefreshRequested?: string;
  accounts: BankFeedConnectionAccountDto[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** BankFeedConnectionRefreshAttemptDto */
export interface BankFeedConnectionRefreshAttemptDto {
  id: string;
  status: string;
  bankFeedSyncId?: string;
  chargeReference?: string;
  /** @format double */
  chargeAmount?: number;
  chargeCurrency?: string;
  failureCode?: string;
  failureMessage?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** BankFeedConnectionRefreshCapabilityDto */
export interface BankFeedConnectionRefreshCapabilityDto {
  canRequestRefresh: boolean;
  blockers: BankFeedConnectionRefreshBlockerCode[];
  /** @format date-time */
  nextRequestAllowed?: string;
}

/** BankFeedLinkTokenDto */
export interface BankFeedLinkTokenDto {
  linkToken: string;
  /** @format date-time */
  expiration?: string;
}

/** BankFeedPublicTokenExchangeDto */
export interface BankFeedPublicTokenExchangeDto {
  /**
   * @minLength 0
   * @maxLength 256
   */
  publicToken: string;
}

/** BankFeedPublicTokenExchangeResultDto */
export interface BankFeedPublicTokenExchangeResultDto {
  connection: BankFeedConnectionDto;
  connectedAccounts: BankFeedConnectionAccountDto[];
  accountMatches: BankFeedAccountMatchResultDto[];
}

/** BankFeedReauthenticationCompletionDto */
export interface BankFeedReauthenticationCompletionDto {
  bankFeedConnectionId: string;
  status: string;
}

/** BankFeedRefreshAttemptDto */
export interface BankFeedRefreshAttemptDto {
  bankFeedConnectionId: string;
  refreshAttemptId: string;
  status: string;
  bankFeedSyncId?: string;
  chargeReference?: string;
  /** @format double */
  chargeAmount?: number;
  chargeCurrency?: string;
  failureCode?: string;
  failureMessage?: string;
}

/** BankFeedSandboxPublicTokenDto */
export interface BankFeedSandboxPublicTokenDto {
  /**
   * @minLength 0
   * @maxLength 64
   */
  institutionId: string;
  /**
   * @minLength 0
   * @maxLength 128
   */
  username: string;
  /**
   * @minLength 0
   * @maxLength 128
   */
  password: string;
}

/** BankFeedSandboxPublicTokenResultDto */
export interface BankFeedSandboxPublicTokenResultDto {
  publicToken: string;
}

/** BankFeedSyncDto */
export interface BankFeedSyncDto {
  id: string;
  trigger: string;
  status: string;
  /** @format date-time */
  started: string;
  /** @format date-time */
  completed?: string;
  /** @format int32 */
  addedCount: number;
  /** @format int32 */
  modifiedCount: number;
  /** @format int32 */
  removedCount: number;
  refreshAttemptId?: string;
  failureCode?: string;
  failureMessage?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** BankLedgerTransferDto */
export interface BankLedgerTransferDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  transferDate: string;
  transferType: BankLedgerTransferType;
  /** @format double */
  amount: number;
  propertyId?: string;
  paymentMethod?: TransactionPaymentMethod;
  outTransactionId?: string;
  inTransactionId?: string;
  outgoing?: BankLedgerTransferSideDto;
  incoming?: BankLedgerTransferSideDto;
  offsetAccount?: OffsetAccountInfoDto;
  memo?: string;
  reference?: string;
  metadata: Record<string, string>;
  creator: CreatorDto;
  /** @format date-time */
  deleted?: string;
}

/** BankLedgerTransferDtoPaginationDto */
export interface BankLedgerTransferDtoPaginationDto {
  items: BankLedgerTransferDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** BankLedgerTransferReconciliationCandidatePayloadDto */
export type BankLedgerTransferReconciliationCandidatePayloadDto = (UtilRequiredKeys<BaseReconciliationCandidatePayloadDto, 'type'> & {
  chartOfAccountId?: string;
  cashChartOfAccountId?: string;
  propertyId?: string;
  portfolioId?: string;
  memo?: string;
}) & {
  type: 'bankLedgerTransfer';
};

/** BankLedgerTransferSideDto */
export interface BankLedgerTransferSideDto {
  bankAccountId?: string;
  cashChartOfAccountId?: string;
}

/** CancelManualReconciliationDto */
export interface CancelManualReconciliationDto {
  memo?: string;
}

/** CashFlowStatementDto */
export interface CashFlowStatementDto {
  title: string;
  operatingRevenue: ReportSectionDto;
  operatingExpenses: ReportSectionDto;
  operatingDeposits: ReportSectionDto;
  /** @format double */
  netCashFromOperations: number;
  nonOperatingRevenue: ReportSectionDto;
  nonOperatingExpenses: ReportSectionDto;
  /** @format double */
  netNonOperatingIncome: number;
  investingActivities: ReportSectionDto;
  /** @format double */
  netCashFromInvesting: number;
  financingActivities: ReportSectionDto;
  /** @format double */
  netCashFromFinancing: number;
  /** @format double */
  netChangeInCash: number;
  /** @format double */
  beginningCashBalance: number;
  /** @format double */
  endingCashBalance: number;
}

/** ChartOfAccountDto */
export interface ChartOfAccountDto {
  id: string;
  parentId?: string;
  /** @format int32 */
  number?: number;
  type: ChartOfAccountType;
  name: string;
  description?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  creator: CreatorDto;
}

/** ChartOfAccountsDto */
export interface ChartOfAccountsDto {
  chartOfAccounts: ChartOfAccountDto[];
}

/** CompleteManualReconciliationDto */
export interface CompleteManualReconciliationDto {
  memo?: string;
}

/** CreateBankAccountRequestDto */
export interface CreateBankAccountRequestDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  accountNumber?: string;
  /**
   * @minLength 0
   * @maxLength 20
   */
  routingNumber?: string;
  type?: BankAccountType;
  companyAccount: boolean;
  scheduledSweepDays?: number[];
  /** @minItems 1 */
  chartOfAccountIds?: string[];
}

/** CreateChartOfAccountRequestDto */
export interface CreateChartOfAccountRequestDto {
  parentId?: string;
  /**
   * @format int32
   * @min 100000
   * @max 899999
   */
  number?: number;
  type: ChartOfAccountType;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  description?: string;
}

/** CreateDepositSlipRequestDto */
export interface CreateDepositSlipRequestDto {
  transactionIds: string[];
  /** @format date */
  deposited?: string;
}

/** CreateManualJournalEntryRequestDto */
export interface CreateManualJournalEntryRequestDto {
  companyBill: boolean;
  /** @format date-time */
  postingDate: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  status: ManualJournalEntryStatus;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  rejectionReason?: string;
  /** @minItems 2 */
  lines: CreateManualJournalLineRequestDto[];
}

/** CreateManualJournalLineRequestDto */
export interface CreateManualJournalLineRequestDto {
  /** @minLength 1 */
  chartOfAccountId: string;
  bankAccountId?: string;
  /**
   * @format double
   * @min 0.01
   * @max 999999999.99
   */
  amount: number;
  isDebit: boolean;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  order: number;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  ownerId?: string;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  tenantId?: string;
  vendorId?: string;
}

/** CreateOwnerPackageRequestDto */
export interface CreateOwnerPackageRequestDto {
  ownerId: string;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
  includeBillInvoices: boolean;
  reportTypes: OwnerPackageReportType[];
}

/** CreateReconciliationPeriodDto */
export interface CreateReconciliationPeriodDto {
  /** @minLength 1 */
  bankAccountId: string;
  /** @format date */
  periodStart?: string;
  /** @format date */
  periodEnd: string;
  /** @format double */
  openingBalance?: number;
  /** @format double */
  closingBalance: number;
}

/** CreateVendorBillLineItemDto */
export interface CreateVendorBillLineItemDto {
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /** @format double */
  amount: number;
}

/** CreateVendorBillRequestDto */
export interface CreateVendorBillRequestDto {
  companyBill: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  reference?: string;
  vendorId: string;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  /** @minItems 1 */
  lineItems: CreateVendorBillLineItemDto[];
}

/** CreatorDto */
export interface CreatorDto {
  type: MagicUserType;
  id?: string;
  deleted?: boolean;
  source: CreationSource;
  /**
   * [DEPRECATED] Use Type = MagicUserType.PropertyManager and Id instead.
   * @deprecated
   */
  propertyManagerId?: string;
  /**
   * [DEPRECATED] Use Type = MagicUserType.Tenant and Id instead.
   * @deprecated
   */
  tenantId?: string;
  /**
   * [DEPRECATED] Use Type = MagicUserType.Vendor and Id instead.
   * @deprecated
   */
  vendorId?: string;
  /**
   * [DEPRECATED] Use Type = MagicUserType.Owner and Id instead.
   * @deprecated
   */
  ownerId?: string;
}

/** DailyMoneyMovementBucketDto */
export interface DailyMoneyMovementBucketDto {
  /** @format date */
  date: string;
  /** @format int32 */
  inCount: number;
  /** @format double */
  inAmount: number;
  /** @format int32 */
  outCount: number;
  /** @format double */
  outAmount: number;
}

/** DailyMoneyMovementDto */
export interface DailyMoneyMovementDto {
  days: DailyMoneyMovementBucketDto[];
}

/** DeleteChartOfAccountRequestDto */
export interface DeleteChartOfAccountRequestDto {
  /** @minLength 1 */
  replacementAccountId: string;
}

/** DeleteVendorBillFilesRequestDto */
export interface DeleteVendorBillFilesRequestDto {
  /** @minItems 1 */
  fileIds: string[];
}

/** DeleteVendorBillRequestDto */
export interface DeleteVendorBillRequestDto {
  adjustPayments: boolean;
}

/** DepositSlipCandidateDto */
export interface DepositSlipCandidateDto {
  /** Transaction ID available for deposit slip grouping. */
  id: string;
  /** Bank account containing the transaction. */
  bankAccountId: string;
  /** Transaction type (Payment, Deposit, …). */
  type: TransactionType;
  /** Transaction identity used by Accounting posting/matching branches. */
  identity: TransactionIdentity;
  /**
   * Signed cash amount of the transaction.
   * @format double
   */
  amount: number;
  /** Cash direction of the transaction. */
  direction: TransactionDirection;
  /** Payment method recorded on the transaction (Cash, Check, ACH, …). */
  paymentMethod: TransactionPaymentMethod;
  /** Current transaction status. */
  status: TransactionStatus;
  /**
   * Company-local transaction date.
   * @format date
   */
  transactionDate: string;
  /**
   * Company-local finalized date, when present.
   * @format date
   */
  finalizedDate?: string;
  /** Transaction memo. */
  memo?: string;
  /** Transaction reference. */
  reference?: string;
  /** Property ID associated with the transaction, when present. */
  propertyId?: string;
  /** Property display name associated with the transaction, when present. */
  propertyName?: string;
  /** Lease ID associated with the transaction, when present. */
  leaseId?: string;
  /** Lease display name associated with the transaction, when present. */
  leaseName?: string;
  /** Resolved party — the most specific of tenant, owner, vendor, subsidizer, or rental application. */
  partyId?: string;
  /** Resolved party display name. */
  partyName?: string;
  /** Resolved party type: Tenant, Owner, Vendor, Subsidizer, or RentalApplication. */
  partyType?: PartyType;
}

/** DepositSlipCandidateDtoPaginationDto */
export interface DepositSlipCandidateDtoPaginationDto {
  items: DepositSlipCandidateDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** DepositSlipDetailDto */
export interface DepositSlipDetailDto {
  id: string;
  bankAccountId: string;
  bankAccountName: string;
  reference: string;
  /** @format date */
  deposited: string;
  /** @format int32 */
  transactionCount: number;
  /** @format double */
  totalAmount: number;
  creator: CreatorDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  entries: DepositSlipEntryDto[];
}

/** DepositSlipEntryDto */
export interface DepositSlipEntryDto {
  /** Transaction ID claimed by this deposit slip entry. */
  transactionId: string;
  /** Immutable transaction evidence captured when the deposit slip entry was created. */
  transactionSnapshot: DepositSlipTransactionSnapshotDto;
  propertyName?: string;
  leaseName?: string;
  partyId?: string;
  partyName?: string;
  partyType?: PartyType;
}

/** DepositSlipItemDto */
export interface DepositSlipItemDto {
  id: string;
  bankAccountId: string;
  bankAccountName: string;
  reference: string;
  /** @format date */
  deposited: string;
  /** @format int32 */
  transactionCount: number;
  /** @format double */
  totalAmount: number;
  creator: CreatorDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** DepositSlipItemsDto */
export interface DepositSlipItemsDto {
  items: DepositSlipItemDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** DepositSlipTransactionSnapshotDto */
export interface DepositSlipTransactionSnapshotDto {
  /** @format int32 */
  version: number;
  type: TransactionType;
  identity: TransactionIdentity;
  direction: TransactionDirection;
  /** @format double */
  amount: number;
  paymentMethod: TransactionPaymentMethod;
  status: TransactionStatus;
  /** @format date */
  transactionDate: string;
  /** @format date */
  finalizedDate?: string;
  memo?: string;
  reference?: string;
  propertyId?: string;
  leaseId?: string;
}

/** GeneralLedgerDto */
export interface GeneralLedgerDto {
  chartOfAccounts: GeneralLedgerSectionDto[];
}

/** GeneralLedgerEntryDto */
export interface GeneralLedgerEntryDto {
  /** @format date */
  date: string;
  portfolioId: string;
  propertyId: string;
  propertyName: string;
  leaseId: string;
  partyInfo: PartyInfoDto;
  /** @format double */
  debit: number;
  /** @format double */
  credit: number;
  /** @format double */
  runningBalance: number;
  memo: string;
  sourceId: string;
  sourceType: JournalEntrySourceType;
  entityType: JournalEntryType;
}

/** GeneralLedgerSectionDto */
export interface GeneralLedgerSectionDto {
  /** @format int64 */
  coaId: string;
  coaName: string;
  /** @format double */
  openingBalance: number;
  entries: GeneralLedgerEntryDto[];
  /** @format double */
  netChange: number;
  /** @format double */
  totalDebit: number;
  /** @format double */
  totalCredit: number;
  /** @format double */
  totalBalance: number;
}

/** IncomeStatementDto */
export interface IncomeStatementDto {
  revenue: ReportSectionDto;
  expenses: ReportSectionDto;
  otherRevenue: ReportSectionDto;
  otherExpenses: ReportSectionDto;
  /** @format double */
  netOperatingIncome: number;
  /** @format double */
  netOtherOperatingIncome: number;
  /** @format double */
  netIncome: number;
}

/** LeaseChargeReconciliationCandidatePayloadDto */
export type LeaseChargeReconciliationCandidatePayloadDto = (UtilRequiredKeys<BaseReconciliationCandidatePayloadDto, 'type'> & {
  leaseId?: string;
  tenantId?: string;
  memo?: string;
}) & {
  type: 'leaseCharge';
};

/** LeaseDepositReconciliationCandidatePayloadDto */
export type LeaseDepositReconciliationCandidatePayloadDto = (UtilRequiredKeys<BaseReconciliationCandidatePayloadDto, 'type'> & {
  leaseId?: string;
  tenantId?: string;
  memo?: string;
}) & {
  type: 'leaseDeposit';
};

/** ManualJournalEntryDto */
export interface ManualJournalEntryDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  companyBill: boolean;
  /** @format date-time */
  postingDate: string;
  description?: string;
  status: ManualJournalEntryStatus;
  rejectionReason?: string;
  creator: CreatorDto;
  submittedByUserId?: string;
  /** @format date-time */
  submittedAt?: string;
  approvedByUserId?: string;
  /** @format date-time */
  approvedAt?: string;
  postedByUserId?: string;
  /** @format date-time */
  postedAt?: string;
  rejectedByUserId?: string;
  /** @format date-time */
  rejectedAt?: string;
  lines: ManualJournalLineDto[];
  chartOfAccounts: ChartOfAccountDto[];
}

/** ManualJournalEntryItemDto */
export interface ManualJournalEntryItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  companyBill: boolean;
  /** @format date-time */
  postingDate: string;
  description?: string;
  status: ManualJournalEntryStatus;
  rejectionReason?: string;
  creator: CreatorDto;
  submittedByUserId?: string;
  /** @format date-time */
  submittedAt?: string;
  approvedByUserId?: string;
  /** @format date-time */
  approvedAt?: string;
  postedByUserId?: string;
  /** @format date-time */
  postedAt?: string;
  rejectedByUserId?: string;
  /** @format date-time */
  rejectedAt?: string;
  lines: ManualJournalLineDto[];
}

/** ManualJournalEntryPaginationDto */
export interface ManualJournalEntryPaginationDto {
  items: ManualJournalEntryItemDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  chartOfAccounts: ChartOfAccountDto[];
}

/** ManualJournalLineDto */
export interface ManualJournalLineDto {
  id?: string;
  chartOfAccountId: string;
  bankAccountId?: string;
  /** @format double */
  amount: number;
  isDebit: boolean;
  /** @format int32 */
  order: number;
  description?: string;
  ownerId?: string;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  tenantId?: string;
  vendorId?: string;
}

/** ManualReconciliationCandidateDto */
export interface ManualReconciliationCandidateDto {
  transactionId: string;
  depositSlipId?: string;
  type: TransactionType;
  identity: TransactionIdentity;
  /** @format double */
  amount: number;
  direction: TransactionDirection;
  paymentMethod: TransactionPaymentMethod;
  status: TransactionStatus;
  /** @format date */
  transactionDate: string;
  memo?: string;
  /** Property ID associated with the transaction, when present. */
  propertyId?: string;
  /** Property display name associated with the transaction, when present. */
  propertyName?: string;
  /** Lease ID associated with the transaction, when present. */
  leaseId?: string;
  /** Lease display name associated with the transaction, when present. */
  leaseName?: string;
  /** Resolved party display name (payee/payer). */
  partyName?: string;
  /** Resolved party ID, when present. */
  partyId?: string;
  /** Resolved party type: Tenant, Owner, Vendor, Subsidizer, or RentalApplication. */
  partyType?: PartyType;
  /** If the transaction is selected for the reconciliation */
  isSelected: boolean;
  /** If the transaction is not in the reconciliation entries, this will be null */
  selectedType?: ManualReconciliationEntryType;
}

/** ManualReconciliationCandidatesDto */
export interface ManualReconciliationCandidatesDto {
  candidates: ManualReconciliationCandidateDto[];
  depositSlips: ManualReconciliationDepositSlipDto[];
}

/** ManualReconciliationDepositSlipDto */
export interface ManualReconciliationDepositSlipDto {
  id: string;
  reference: string;
  /** @format date */
  deposited: string;
}

/** ManualReconciliationDetailDto */
export interface ManualReconciliationDetailDto {
  id: string;
  bankAccountId: string;
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate: string;
  /** @format double */
  opening: number;
  /** @format double */
  additions: number;
  /** @format double */
  subtractions: number;
  /** @format double */
  closing: number;
  status: ManualReconciliationStatus;
  creator: CreatorDto;
  memo?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  entries: ManualReconciliationEntryDto[];
  /** @format double */
  actualAdditions: number;
  /** @format double */
  actualSubtractions: number;
  /** @format double */
  actualClosing: number;
  /** @format double */
  additionsDifference: number;
  /** @format double */
  subtractionsDifference: number;
  /** @format double */
  closingDifference: number;
  depositSlips: ManualReconciliationDepositSlipDto[];
}

/** ManualReconciliationDto */
export interface ManualReconciliationDto {
  id: string;
  bankAccountId: string;
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate: string;
  /** @format double */
  opening: number;
  /** @format double */
  additions: number;
  /** @format double */
  subtractions: number;
  /** @format double */
  closing: number;
  status: ManualReconciliationStatus;
  creator: CreatorDto;
  memo?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** ManualReconciliationEntryDto */
export interface ManualReconciliationEntryDto {
  transactionId: string;
  depositSlipId?: string;
  type: ManualReconciliationEntryType;
  /** Immutable transaction evidence captured when the entry was created. */
  transactionSnapshot: ManualReconciliationTransactionSnapshotDto;
  propertyName?: string;
  leaseName?: string;
  partyName?: string;
  partyId?: string;
  partyType?: PartyType;
}

/** ManualReconciliationTransactionSnapshotDto */
export interface ManualReconciliationTransactionSnapshotDto {
  /** @format int32 */
  version: number;
  type: TransactionType;
  identity: TransactionIdentity;
  /** @format double */
  amount: number;
  direction: TransactionDirection;
  paymentMethod: TransactionPaymentMethod;
  status: TransactionStatus;
  /** @format date */
  transactionDate: string;
  /** @format date */
  finalizedDate?: string;
  memo?: string;
  reference?: string;
  propertyId?: string;
  leaseId?: string;
}

/** ManualReconciliationsDto */
export interface ManualReconciliationsDto {
  items: ManualReconciliationDto[];
}

/** MasterLedgerEntryDto */
export interface MasterLedgerEntryDto {
  /** @format date */
  postingDate: string;
  source: JournalEntrySourceType;
  sourceId: string;
  lines: MasterLedgerLineDto[];
}

/** MasterLedgerLineDto */
export interface MasterLedgerLineDto {
  coaId: string;
  coaName: string;
  /** @format double */
  amount: number;
  isDebit: boolean;
  description: string;
  propertyId: string;
  leaseId: string;
  vendorId: string;
  tenantId: string;
  ownerId: string;
  rentalApplicationId: string;
}

/** MatchingReconciliationCandidateDto */
export type MatchingReconciliationCandidateDto = (UtilRequiredKeys<BaseReconciliationCandidateDto, 'type'> & {
  /** Existing Accounting transaction IDs proposed for matching. */
  transactionIds: string[];
}) & {
  type: 'matching';
};

/** OffsetAccountInfoDto */
export interface OffsetAccountInfoDto {
  /** @minLength 1 */
  chartOfAccountId: string;
}

/** OnTimeRentPaymentSummaryDto */
export interface OnTimeRentPaymentSummaryDto {
  /** @format int32 */
  totalCharges: number;
  /** @format int32 */
  onTimeCharges: number;
  /** @format double */
  onTimePercentage: number;
}

/** OnlinePaymentsSummaryDto */
export interface OnlinePaymentsSummaryDto {
  /** @format int32 */
  totalLeasePayments: number;
  /** @format int32 */
  onlineLeasePayments: number;
  /** @format double */
  onlinePercentage: number;
  /** @format double */
  onlinePercentageAverage: number;
}

/** OwnerContributionReconciliationCandidatePayloadDto */
export type OwnerContributionReconciliationCandidatePayloadDto = (UtilRequiredKeys<BaseReconciliationCandidatePayloadDto, 'type'> & {
  ownerId?: string;
  /** Property allocations proposed by this Owner Contribution Candidate. */
  targets: OwnerTransferTargetCandidateDto[];
  cashChartOfAccountId?: string;
  memo?: string;
}) & {
  type: 'ownerContribution';
};

/** OwnerDistributionReconciliationCandidatePayloadDto */
export type OwnerDistributionReconciliationCandidatePayloadDto = (UtilRequiredKeys<BaseReconciliationCandidatePayloadDto, 'type'> & {
  ownerId?: string;
  /** Property allocations proposed by this Owner Distribution Candidate. */
  targets: OwnerTransferTargetCandidateDto[];
  cashChartOfAccountId?: string;
  memo?: string;
}) & {
  type: 'ownerDistribution';
};

/** OwnerPackageDto */
export interface OwnerPackageDto {
  id: string;
  ownerId: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  includeBillInvoices: boolean;
  reportTypes: string[];
  fileId: string;
  fileUrl: string;
  /** @format date-time */
  created: string;
}

/** OwnerPackageDtoPaginationDto */
export interface OwnerPackageDtoPaginationDto {
  items: OwnerPackageDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** OwnerStatementDto */
export interface OwnerStatementDto {
  entries: OwnerStatementEntryDto[];
  summary: SummaryDto;
}

/** OwnerStatementEntryDto */
export interface OwnerStatementEntryDto {
  propertyId: string;
  portfolioId: string;
  propertyName: string;
  summary: SummaryDto;
  transactions: TransactionEntryDto[];
  unpaidBills: UnpaidBillDto[];
}

/** OwnerTransferTargetCandidateDto */
export interface OwnerTransferTargetCandidateDto {
  /** Property ID allocated by this Posting Candidate. */
  propertyId: string;
  /**
   * Positive amount allocated to the Property.
   * @format double
   */
  amount: number;
}

/** OwnerTransferTargetDto */
export interface OwnerTransferTargetDto {
  /**
   * Property ID receiving this Owner allocation.
   * @minLength 1
   */
  propertyId: string;
  /**
   * Positive amount allocated to this Property.
   * @format double
   * @min 0.01
   * @max 999999999.99
   */
  amount: number;
}

/** PartyInfoDto */
export interface PartyInfoDto {
  id: string;
  type: PartyType;
  name: string;
}

/** PaymentEventDto */
export interface PaymentEventDto {
  /** @format int64 */
  transactionId: string;
  /** @format double */
  amount: number;
  /** @format date-time */
  transactionDate: string;
  status: TransactionStatus;
  paymentMethod: TransactionPaymentMethod;
  /** @format int64 */
  linkedTransactionId?: string;
  /** @format int64 */
  leaseId?: string;
  /** @format int64 */
  unitId?: string;
  unitName?: string;
  /** @format int64 */
  propertyId?: string;
  propertyName?: string;
}

/** PaymentEventGroupDto */
export interface PaymentEventGroupDto {
  /** @format int32 */
  count: number;
  /** @format double */
  amount: number;
  items: PaymentEventDto[];
}

/** PostBankLedgerTransferRequestDto */
export interface PostBankLedgerTransferRequestDto {
  /** @format date-time */
  transferDate?: string;
  transferType: BankLedgerTransferType;
  /**
   * @format double
   * @min 0.01
   * @max 999999999.99
   */
  amount: number;
  propertyId?: string;
  paymentMethod?: TransactionPaymentMethod;
  outgoing?: BankLedgerTransferSideDto;
  incoming?: BankLedgerTransferSideDto;
  offsetAccount?: OffsetAccountInfoDto;
  externalTransactionType?: ExternalTransactionType;
  /**
   * @minLength 0
   * @maxLength 200
   */
  externalTransactionId?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  reference?: string;
  metadata?: Record<string, string>;
}

/** PostManualJournalEntryRequestDto */
export interface PostManualJournalEntryRequestDto {
  /** @minLength 1 */
  postedById: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  reason?: string;
}

/** PostingReconciliationCandidateDto */
export type PostingReconciliationCandidateDto = (UtilRequiredKeys<BaseReconciliationCandidateDto, 'type'> & {
  /** Posting identity represented by the concrete payload. */
  identity: TransactionIdentity;
  /** Identity-specific Posting suggestion. Nullable fields mean the generator could not determine a value; the front end must prompt the PM to supply it before accepting or pre-fill a manual resolve form. */
  payload:
    | BankLedgerTransferReconciliationCandidatePayloadDto
    | LeaseChargeReconciliationCandidatePayloadDto
    | LeaseDepositReconciliationCandidatePayloadDto
    | OwnerDistributionReconciliationCandidatePayloadDto
    | OwnerContributionReconciliationCandidatePayloadDto;
}) & {
  type: 'posting';
};

/** ReconciliationCandidateBillAllocationDto */
export interface ReconciliationCandidateBillAllocationDto {
  /** Vendor Bill ID allocated by this Candidate. */
  billId: string;
  /**
   * Positive amount allocated to the Vendor Bill.
   * @format double
   */
  amount: number;
}

/** ReconciliationCandidateGenerationDto */
export interface ReconciliationCandidateGenerationDto {
  status: ReconciliationCandidateGenerationStatus;
  /** @format date-time */
  requested?: string;
  /** @format date-time */
  completed?: string;
}

/** ReconciliationChartOfAccountDto */
export interface ReconciliationChartOfAccountDto {
  id: string;
  /** @format int32 */
  number?: number;
  name: string;
}

/** ReconciliationItemCapabilitiesDto */
export interface ReconciliationItemCapabilitiesDto {
  canMatchExistingTransaction: boolean;
  canSettle: boolean;
  canPost: boolean;
  canIgnore: boolean;
  canAcknowledgeReview: boolean;
  canRefreshCandidates: boolean;
  blockers: ReconciliationItemActionBlocker[];
}

/** ReconciliationItemDetailDto */
export interface ReconciliationItemDetailDto {
  id: string;
  bankAccountId: string;
  bankFeedEntryId: string;
  /** Derived from resolution and review — not a stored field. Open = no resolution; NeedsReview = resolved but a supporting fact changed; Completed = resolved and no outstanding review. */
  status: ReconciliationItemStatus;
  /**
   * Signed amount from the bank feed. Positive = inflow (deposit), negative = outflow (withdrawal).
   * @format double
   */
  amount: number;
  /** @format date-time */
  occurred: string;
  description: string;
  /** How the bank-feed entry was imported (for example Plaid sync vs manual import). */
  sourceType: BankFeedSourceType;
  /** Provider-side entry status. A Retracted entry on a resolved item raises a review; the item stays visible with NeedsReview until acknowledged or rematched. */
  entryStatus: BankFeedEntryStatus;
  /** Locked reconciliation period ID when this item is included in a locked period. Null when the item is not locked into a period. */
  lockedPeriodId?: string;
  /**
   * Number of current disposable candidates. Useful for Open-item list badges without loading candidate payloads.
   * @format int32
   */
  candidateCount: number;
  /** Null when no generation has ever been requested. Poll Status to drive the generate-then-poll lifecycle. */
  candidateGeneration?: ReconciliationCandidateGenerationDto;
  /** Null when the item is still Open (no confirmed resolution). */
  resolution?: ReconciliationResolutionDto;
  /** Null when no review is active. Present when a supporting fact changed after resolution. */
  review?: ReconciliationReviewDto;
  /**
   * Company-local timestamp when the reconciliation item was created.
   * @format date-time
   */
  created: string;
  /**
   * Company-local timestamp when the reconciliation item was last updated.
   * @format date-time
   */
  updated: string;
  /** Provider-supplied metadata key-value pairs on the bank-feed entry. */
  metadata: Record<string, string>;
  /** Disposable suggestion set, not audit history. Replaced atomically on regeneration; cleared on resolution, invalidation, or review. Exact acceptance retains only the selected one while its Resolution is active. */
  candidates: (MatchingReconciliationCandidateDto | SettlingReconciliationCandidateDto | PostingReconciliationCandidateDto)[];
  /** Each link carries a frozen snapshot at link time; the live transaction may have since changed, which is what the review system detects. */
  transactionLinks: ReconciliationTransactionLinkDto[];
  /** Advisory business-state snapshot, not authorization. Render blockers to explain disabled actions; do not use these flags alone for access control. */
  capabilities: ReconciliationItemCapabilitiesDto;
  chartOfAccounts: ReconciliationChartOfAccountDto[];
  transactions: ReconciliationTransactionDto[];
  /** Vendor Bill display records referenced by current Settling Candidates. */
  vendorBills: ReconciliationVendorBillDto[];
  portfolios: ReconciliationReferenceDto[];
  properties: ReconciliationReferenceDto[];
  leases: ReconciliationReferenceDto[];
  tenants: ReconciliationReferenceDto[];
  owners: ReconciliationReferenceDto[];
}

/** ReconciliationItemListDto */
export interface ReconciliationItemListDto {
  id: string;
  bankAccountId: string;
  bankFeedEntryId: string;
  /** Derived from resolution and review — not a stored field. Open = no resolution; NeedsReview = resolved but a supporting fact changed; Completed = resolved and no outstanding review. */
  status: ReconciliationItemStatus;
  /**
   * Signed amount from the bank feed. Positive = inflow (deposit), negative = outflow (withdrawal).
   * @format double
   */
  amount: number;
  /** @format date-time */
  occurred: string;
  description: string;
  /** How the bank-feed entry was imported (for example Plaid sync vs manual import). */
  sourceType: BankFeedSourceType;
  /** Provider-side entry status. A Retracted entry on a resolved item raises a review; the item stays visible with NeedsReview until acknowledged or rematched. */
  entryStatus: BankFeedEntryStatus;
  /** Locked reconciliation period ID when this item is included in a locked period. Null when the item is not locked into a period. */
  lockedPeriodId?: string;
  /**
   * Number of current disposable candidates. Useful for Open-item list badges without loading candidate payloads.
   * @format int32
   */
  candidateCount: number;
  /** Null when no generation has ever been requested. Poll Status to drive the generate-then-poll lifecycle. */
  candidateGeneration?: ReconciliationCandidateGenerationDto;
  /** Null when the item is still Open (no confirmed resolution). */
  resolution?: ReconciliationResolutionDto;
  /** Null when no review is active. Present when a supporting fact changed after resolution. */
  review?: ReconciliationReviewDto;
  /**
   * Company-local timestamp when the reconciliation item was created.
   * @format date-time
   */
  created: string;
  /**
   * Company-local timestamp when the reconciliation item was last updated.
   * @format date-time
   */
  updated: string;
}

/** ReconciliationItemsDto */
export interface ReconciliationItemsDto {
  items: ReconciliationItemListDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** ReconciliationItemsSummaryDto */
export interface ReconciliationItemsSummaryDto {
  total: ReconciliationSummaryMetricDto;
  /** Mutually exclusive and exhaustive item buckets. Total count equals Open + NeedsReview + Completed. */
  byStatus: {
    open?: ReconciliationSummaryMetricDto;
    needsReview?: ReconciliationSummaryMetricDto;
    completed?: ReconciliationSummaryMetricDto;
  };
  /** Resolution buckets across all resolved items, including NeedsReview and Completed. The bucket counts sum to NeedsReview + Completed, not Completed alone. */
  byResolution: {
    matched?: ReconciliationSummaryMetricDto;
    settled?: ReconciliationSummaryMetricDto;
    posted?: ReconciliationSummaryMetricDto;
    ignored?: ReconciliationSummaryMetricDto;
  };
}

/** ReconciliationMatchTargetDto */
export interface ReconciliationMatchTargetDto {
  /** Accounting transaction ID that can be selected for a Match resolution. */
  transactionId: string;
  /** Transaction type (Payment, Deposit, …). */
  type: TransactionType;
  /** Transaction identity used by Accounting posting/matching branches. */
  identity: TransactionIdentity;
  /**
   * Signed cash amount of the transaction.
   * @format double
   */
  amount: number;
  /** Cash direction of the transaction. */
  direction: TransactionDirection;
  /**
   * Company-local transaction date.
   * @format date
   */
  transactionDate: string;
  /**
   * Company-local finalized date, when present.
   * @format date
   */
  finalizedDate?: string;
  /**
   * Company-local financial date used for cash timing.
   * @format date
   */
  financialDate: string;
  /** Current transaction status. Match targets are already limited to balance-affecting statuses. */
  status: TransactionStatus;
  /** Payment method recorded on the transaction (ACH, Check, Wire, …). */
  paymentMethod: TransactionPaymentMethod;
  /** Transaction memo. */
  memo?: string;
  /** Transaction reference. */
  reference?: string;
  /** Property ID associated with the transaction, when present. */
  propertyId?: string;
  /** Property display name associated with the transaction, when present. */
  propertyName?: string;
  /** Lease ID associated with the transaction, when present. */
  leaseId?: string;
  /** Lease display name associated with the transaction, when present. */
  leaseName?: string;
  /** Resolved party — the most specific of tenant, owner, vendor, subsidizer, or rental application. */
  partyId?: string;
  /** Resolved party display name. */
  partyName?: string;
  /** Resolved party type: Tenant, Owner, Vendor, Subsidizer, or RentalApplication. */
  partyType?: PartyType;
}

/** ReconciliationMatchTargetDtoPaginationDto */
export interface ReconciliationMatchTargetDtoPaginationDto {
  items: ReconciliationMatchTargetDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** ReconciliationPeriodBankAccountDto */
export interface ReconciliationPeriodBankAccountDto {
  id: string;
  name: string;
  accountNumberLast4?: string;
}

/** ReconciliationPeriodBlockerDto */
export interface ReconciliationPeriodBlockerDto {
  action: ReconciliationPeriodAction;
  type: ReconciliationPeriodBlockerType;
  /** Id of the related entity that caused this blocker (period, bank-feed entry, reconciliation item, or disposition), when applicable. Null for period-level blockers such as BalanceDifference. */
  relatedId?: string;
}

/** ReconciliationPeriodCapabilitiesDto */
export interface ReconciliationPeriodCapabilitiesDto {
  /** Null when the whole period is not editable. When present, each flag indicates whether that specific field can be edited; the first period additionally allows editing OpeningBalance and PeriodStart. */
  canEdit?: ReconciliationPeriodEditCapabilitiesDto;
  canDelete: boolean;
  canLock: boolean;
  canReopen: boolean;
}

/** ReconciliationPeriodDetailDto */
export interface ReconciliationPeriodDetailDto {
  id: string;
  /** @format date */
  periodStart: string;
  /** @format date */
  periodEnd: string;
  status: ReconciliationPeriodStatus;
  /** Derived validity of a Locked period. Valid = no open disposition directly affects this period and no earlier period is invalidated; Invalidated = an unacknowledged disposition directly affects this period; Impacted = an earlier period is invalidated, so this period's reconciliation truth is indirectly affected. Draft and Reopened periods are always Valid. */
  validity: ReconciliationPeriodValidityDto;
  bankAccount: ReconciliationPeriodBankAccountDto;
  /** Bank-side reconciliation figures derived from active bank-feed entries in the period. A non-zero Difference blocks locking. */
  financialSummary: ReconciliationPeriodFinancialSummaryDto;
  /** Counts of reconciliation items belonging to the period's bank-feed entries. Total = all active entries; Open = no confirmed resolution; NeedsReview = resolved but a supporting fact changed. */
  itemSummary: ReconciliationPeriodItemSummaryDto;
  /** Summary of the period's lock history. A locked period has at least one snapshot; reopen preserves prior history and relock appends a new snapshot. */
  lockSummary: ReconciliationPeriodLockSummaryDto;
  /** Property-manager acknowledgements of facts that changed after this period was locked. One disposition is acknowledged once on the directly affected period; it is not copied to later periods. */
  dispositions: ReconciliationPeriodDispositionDto[];
  /** Advisory business-state snapshot, not authorization. Render blockers to explain disabled actions; do not use these flags alone for access control. */
  capabilities: ReconciliationPeriodCapabilitiesDto;
  /** Reasons why a period action (Edit/Delete/Lock/Reopen) is currently blocked. Render these to explain disabled actions; each blocker references the action it blocks and an optional related entity id. */
  blockers: ReconciliationPeriodBlockerDto[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** ReconciliationPeriodDispositionDto */
export interface ReconciliationPeriodDispositionDto {
  id: string;
  reconciliationItemId?: string;
  bankFeedEntryId?: string;
  transactionId?: string;
  status: ReconciliationPeriodDispositionStatus;
  reason: ReconciliationPeriodInvalidationReason;
  /** @format date-time */
  acknowledged?: string;
  acknowledgedBy?: string;
  canAcknowledge: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** ReconciliationPeriodDto */
export interface ReconciliationPeriodDto {
  id: string;
  bankAccountId: string;
  /** @format date */
  periodStart: string;
  /** @format date */
  periodEnd: string;
  /** @format double */
  openingBalance: number;
  /** @format double */
  closingBalance: number;
  status: ReconciliationPeriodStatus;
  validityStatus: ReconciliationPeriodReadStatus;
  dispositions: ReconciliationPeriodDispositionDto[];
  /** @format date-time */
  locked?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** ReconciliationPeriodEditCapabilitiesDto */
export interface ReconciliationPeriodEditCapabilitiesDto {
  periodStart: boolean;
  periodEnd: boolean;
  openingBalance: boolean;
  closingBalance: boolean;
}

/** ReconciliationPeriodFinancialSummaryDto */
export interface ReconciliationPeriodFinancialSummaryDto {
  /** @format double */
  openingBalance: number;
  /** @format double */
  inflows: number;
  /** @format double */
  outflows: number;
  /**
   * OpeningBalance + Inflows - Outflows across active bank-feed entries in the period. This is a bank-side balance and is independent of whether the corresponding items have a confirmed resolution.
   * @format double
   */
  clearedBalance: number;
  /** @format double */
  closingBalance: number;
  /**
   * ClosingBalance - ClearedBalance. Must be zero for the period to be lockable.
   * @format double
   */
  difference: number;
}

/** ReconciliationPeriodItemDto */
export interface ReconciliationPeriodItemDto {
  bankFeedEntryId: string;
  reconciliationItemId?: string;
  /** @format date */
  occurred: string;
  /** @format double */
  amount: number;
  description: string;
  sourceType: BankFeedSourceType;
  status: ReconciliationItemStatus;
  resolution?: ReconciliationPeriodItemResolutionDto;
  review?: ReconciliationPeriodItemReviewDto;
  transactionLinks: ReconciliationPeriodItemTransactionLinkDto[];
}

/** ReconciliationPeriodItemResolutionDto */
export interface ReconciliationPeriodItemResolutionDto {
  type: ReconciliationResolutionType;
  /** @format date-time */
  resolved: string;
  resolvedBy: string;
  ignoreReason?: ReconciliationIgnoreReason;
  ignoreExplanation?: string;
}

/** ReconciliationPeriodItemReviewDto */
export interface ReconciliationPeriodItemReviewDto {
  reason: ReconciliationReviewReason;
  /** @format date-time */
  raised: string;
  /** @format date-time */
  acknowledged?: string;
}

/** ReconciliationPeriodItemSummaryDto */
export interface ReconciliationPeriodItemSummaryDto {
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  openCount: number;
  /** @format int32 */
  needsReviewCount: number;
  /**
   * Resolved items whose resolution type is Ignored. A subset of Completed, not a separate status.
   * @format int32
   */
  ignoredCount: number;
}

/** ReconciliationPeriodItemTransactionLinkDto */
export interface ReconciliationPeriodItemTransactionLinkDto {
  transactionId: string;
  snapshot: ReconciliationPeriodItemTransactionSnapshotDto;
}

/** ReconciliationPeriodItemTransactionSnapshotDto */
export interface ReconciliationPeriodItemTransactionSnapshotDto {
  /** @format double */
  amount: number;
  direction: TransactionDirection;
  /** @format date */
  transactionDate: string;
  /** @format date */
  finalizedDate?: string;
  /** @format date-time */
  deleted?: string;
}

/** ReconciliationPeriodItemsDto */
export interface ReconciliationPeriodItemsDto {
  items: ReconciliationPeriodItemDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  source: ReconciliationPeriodItemsSource;
  /** @format date-time */
  locked?: string;
}

/** ReconciliationPeriodLockSummaryDto */
export interface ReconciliationPeriodLockSummaryDto {
  /** @format int32 */
  lockCount: number;
  /** @format date-time */
  latestLocked?: string;
  latestLockedBy?: string;
}

/** ReconciliationPeriodValidityDto */
export interface ReconciliationPeriodValidityDto {
  status: ReconciliationPeriodReadStatus;
  /** When Status is Impacted, the earlier Invalidated period ids whose open dispositions propagate to this period. Empty for Valid and Invalidated. */
  sourcePeriodIds: string[];
}

/** ReconciliationPeriodsDto */
export interface ReconciliationPeriodsDto {
  items: ReconciliationPeriodDto[];
}

/** ReconciliationReferenceDto */
export interface ReconciliationReferenceDto {
  id: string;
  name: string;
}

/** ReconciliationResolutionDto */
export interface ReconciliationResolutionDto {
  type: ReconciliationResolutionType;
  /** @format date-time */
  resolved: string;
  /** User or system actor ID that confirmed the resolution. */
  resolvedBy: string;
  /** Ignore reason, present only when Type is ignored. */
  ignoreReason?: ReconciliationIgnoreReason;
  /** Optional free-text explanation, present only when Type is ignored. */
  ignoreExplanation?: string;
}

/** ReconciliationReviewDto */
export interface ReconciliationReviewDto {
  reason: ReconciliationReviewReason;
  /** @format date-time */
  raised: string;
  /**
   * Company-local timestamp when the review was acknowledged. Present only for retracted-source reviews that were acknowledged but not cleared; active-source reviews clear the review entirely.
   * @format date-time
   */
  acknowledged?: string;
}

/** ReconciliationSettleTargetDto */
export interface ReconciliationSettleTargetDto {
  /** Settle target identity. Currently VendorBill. */
  identity: TransactionIdentity;
  /** Vendor Bill ID. Used as the settle target BillId in the resolve request. */
  billId: string;
  /** Whether this Vendor Bill is a company bill (true) or an owner bill (false). */
  companyBill: boolean;
  /** Vendor Bill approval workflow status. */
  status: VendorBillStatus;
  /**
   * Original Vendor Bill total amount.
   * @format double
   */
  totalAmount: number;
  /**
   * Amount already allocated to payments on the Vendor Bill.
   * @format double
   */
  allocatedAmount: number;
  /**
   * Current amount due on the Vendor Bill (TotalAmount - AllocatedAmount).
   * @format double
   */
  dueAmount: number;
  /** Vendor ID associated with the Vendor Bill. */
  payeeId: string;
  /** Display name for the Vendor. */
  payeeName?: string;
  /** Display names for Properties referenced by the Vendor Bill line items. */
  propertyNames: string[];
  /**
   * Company-local Vendor Bill date.
   * @format date
   */
  billDate: string;
  /**
   * Company-local Vendor Bill due date.
   * @format date
   */
  dueDate: string;
  /** Vendor Bill memo. */
  memo?: string;
  /** Vendor Bill reference. */
  reference?: string;
}

/** ReconciliationSettleTargetDtoPaginationDto */
export interface ReconciliationSettleTargetDtoPaginationDto {
  items: ReconciliationSettleTargetDto[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

/** ReconciliationSettledTargetDto */
export interface ReconciliationSettledTargetDto {
  /**
   * Vendor Bill ID receiving this settlement allocation.
   * @minLength 1
   */
  billId: string;
  /**
   * Positive amount allocated to this Bill.
   * @format double
   * @min 0.01
   * @max 999999999.99
   */
  amount: number;
}

/** ReconciliationSummaryDto */
export interface ReconciliationSummaryDto {
  items: ReconciliationItemsSummaryDto;
  /** Balance-affecting Accounting transactions that are not linked to a reconciliation item. This is a diagnostic over book-side activity, not a reconciliation item status or resolution bucket. */
  outstandingBookOnly: ReconciliationSummaryMetricDto;
}

/** ReconciliationSummaryMetricDto */
export interface ReconciliationSummaryMetricDto {
  /** @format int32 */
  count: number;
  /** @format double */
  inflowAmount: number;
  /** @format double */
  outflowAmount: number;
  /** @format double */
  grossAmount: number;
  /** @format double */
  netAmount: number;
}

/** ReconciliationTransactionDto */
export interface ReconciliationTransactionDto {
  id: string;
  type: TransactionType;
  identity: TransactionIdentity;
  direction: TransactionDirection;
  /** @format double */
  amount: number;
  /** @format date */
  transactionDate: string;
  /** @format date */
  finalizedDate?: string;
  /** @format date */
  financialDate: string;
  status: TransactionStatus;
  paymentMethod: TransactionPaymentMethod;
  memo?: string;
  reference?: string;
  portfolioId?: string;
  portfolioName?: string;
  propertyId?: string;
  propertyName?: string;
  unitId?: string;
  unitName?: string;
  leaseId?: string;
  leaseName?: string;
  /** Resolved party — the most specific of tenant, owner, vendor, subsidizer, or rental application. Null for BankLedgerTransfer postings. */
  partyId?: string;
  /** Resolved party display name. */
  partyName?: string;
  /** Resolved party type: Tenant, Owner, Vendor, Subsidizer, or RentalApplication. */
  partyType?: PartyType;
  chartOfAccountId: string;
  chartOfAccountName?: string;
}

/** ReconciliationTransactionLinkDto */
export interface ReconciliationTransactionLinkDto {
  transactionId: string;
  /** Frozen transaction snapshot at link time. Compared against the live transaction by the cash-link integrity scan; drift raises a review. */
  snapshot: ReconciliationTransactionSnapshotDto;
  /** @format date-time */
  created: string;
}

/** ReconciliationTransactionSnapshotDto */
export interface ReconciliationTransactionSnapshotDto {
  /** @format double */
  amount: number;
  direction: TransactionDirection;
  /** @format date */
  transactionDate: string;
  /** @format date */
  finalizedDate?: string;
  /**
   * Soft-delete timestamp captured in the snapshot. If present, the live transaction was deleted after link, which raises a blocking review.
   * @format date-time
   */
  deleted?: string;
}

/** ReconciliationVendorBillDto */
export interface ReconciliationVendorBillDto {
  /** Vendor Bill ID. */
  billId: string;
  /**
   * Current amount due on the Vendor Bill.
   * @format double
   */
  dueAmount: number;
  /** Vendor ID associated with the Vendor Bill. */
  payeeId: string;
  /** Display name for the Vendor. */
  payeeName?: string;
  /** Display names for Properties referenced by the Vendor Bill line items. */
  propertyNames: string[];
  /**
   * Company-local Vendor Bill date.
   * @format date
   */
  billDate: string;
  /**
   * Company-local Vendor Bill due date.
   * @format date
   */
  dueDate?: string;
  /** Vendor Bill memo. */
  memo?: string;
  /** Vendor Bill reference. */
  reference?: string;
}

/** RejectManualJournalEntryRequestDto */
export interface RejectManualJournalEntryRequestDto {
  /** @minLength 1 */
  rejectedById: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  rejectionReason?: string;
}

/** RemoveManualReconciliationEntriesDto */
export interface RemoveManualReconciliationEntriesDto {
  transactionIds?: string[];
  depositSlipIds?: string[];
}

/** RentPaymentEntryDto */
export interface RentPaymentEntryDto {
  transactionId: string;
  /** @format date-time */
  transactionDate: string;
  /** @format date-time */
  finalizedDate?: string;
  propertyId?: string;
  propertyName?: string;
  unitId?: string;
  unitName?: string;
  leaseId?: string;
  payer?: PartyInfoDto;
  type: TransactionType;
  identity: TransactionIdentity;
  paymentMethod: TransactionPaymentMethod;
  externalTransactionType?: ExternalTransactionType;
  /** @format double */
  amount: number;
  direction: TransactionDirection;
  status: TransactionStatus;
  description?: string;
  bankAccountId?: string;
  bankAccountName?: string;
  chartOfAccountId?: string;
  chartOfAccountName?: string;
}

/** RentPaymentsReportDto */
export interface RentPaymentsReportDto {
  entries: RentPaymentEntryDto[];
  /** @format double */
  totalAmount: number;
  /** @format int32 */
  totalCount: number;
}

/** ReportSectionDto */
export interface ReportSectionDto {
  entries: SectionEntryDto[];
  /** @format double */
  totalAmount: number;
}

/** RequestVendorBillUploadSessionDto */
export interface RequestVendorBillUploadSessionDto {
  /** @minLength 1 */
  fileName: string;
  /** @minLength 1 */
  contentType: string;
  /** @format int32 */
  fileSize: number;
}

/** ResolveReconciliationItemAcceptDto */
export type ResolveReconciliationItemAcceptDto = (UtilRequiredKeys<BaseResolveReconciliationItemRequestDto, 'type'> & {
  /**
   * Saved Candidate ID to accept exactly. Do not combine it with transaction IDs, targets, identity, memo, or Posting fields.
   * @minLength 1
   */
  candidateId: string;
}) & {
  type: 'accept';
};

/** ResolveReconciliationItemIgnoreDto */
export type ResolveReconciliationItemIgnoreDto = (UtilRequiredKeys<BaseResolveReconciliationItemRequestDto, 'type'> & {
  /** Business reason for ignoring the bank-feed entry. */
  reason: ReconciliationIgnoreReason;
  /**
   * Optional explanation for the manual ignore decision.
   * @minLength 0
   * @maxLength 1000
   */
  explanation?: string;
}) & {
  type: 'ignore';
};

/** ResolveReconciliationItemMatchDto */
export type ResolveReconciliationItemMatchDto = (UtilRequiredKeys<BaseResolveReconciliationItemRequestDto, 'type'> & {
  /** Existing Accounting transaction IDs that manually explain the bank-feed entry. */
  transactionIds?: string[];
}) & {
  type: 'match';
};

/** ResolveReconciliationItemPostDto */
export type ResolveReconciliationItemPostDto = (UtilRequiredKeys<BaseResolveReconciliationItemRequestDto, 'type'> & {
  /** Posting identity that selects the Accounting branch to execute. */
  identity: TransactionIdentity;
  /** Optional offset Chart of Account ID used by the selected Posting identity. */
  chartOfAccountId?: string;
  /** Optional cash Asset Chart of Account ID. */
  cashChartOfAccountId?: string;
  /** Optional Property ID used by the selected Posting identity. */
  propertyId?: string;
  /** Optional Portfolio ID used by the selected Posting identity. */
  portfolioId?: string;
  /** Optional Lease ID used by a Lease Posting identity. */
  leaseId?: string;
  /** Optional Tenant ID used by a Lease Posting identity. */
  tenantId?: string;
  /** Optional Lease Charge IDs targeted by a LeaseCharge Posting. */
  targetChargeIds?: string[];
  /** Optional Lease Deposit IDs targeted by a LeaseDeposit Posting. */
  targetDepositIds?: string[];
  /** Optional Owner ID used by an Owner Posting identity. */
  ownerId?: string;
  /** Optional Property allocations used by an Owner Posting identity. */
  ownerTransferTargets?: OwnerTransferTargetDto[];
  /**
   * Optional memo for the posted Accounting transaction.
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
}) & {
  type: 'post';
};

/** ResolveReconciliationItemSettleDto */
export type ResolveReconciliationItemSettleDto = (UtilRequiredKeys<BaseResolveReconciliationItemRequestDto, 'type'> & {
  /** Settlement identity. VendorBill is the currently supported value. */
  identity: TransactionIdentity;
  /** Bill allocations whose amounts must sum to the absolute bank-feed entry amount. */
  targets: ReconciliationSettledTargetDto[];
  /**
   * Asset Chart of Account ID used for the settlement payment transaction.
   * @minLength 1
   */
  chartOfAccountId: string;
  /**
   * Optional memo for the settlement payment transaction.
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
}) & {
  type: 'settle';
};

/** ReturnsAndDisputesDto */
export interface ReturnsAndDisputesDto {
  returns: PaymentEventGroupDto;
  disputes: PaymentEventGroupDto;
}

/** SectionEntryDto */
export interface SectionEntryDto {
  chartOfAccountId: string;
  name: string;
  /** @format double */
  amount: number;
  children: SectionEntryDto[];
  /** @format double */
  subTotal: number;
}

/** SetVendorBillSourceRequestDto */
export interface SetVendorBillSourceRequestDto {
  sourceType?: VendorBillSourceType;
  sourceId?: string;
}

/** SettlingReconciliationCandidateDto */
export type SettlingReconciliationCandidateDto = (UtilRequiredKeys<BaseReconciliationCandidateDto, 'type'> & {
  /** Bill allocations proposed by this Settling Candidate. */
  allocations: ReconciliationCandidateBillAllocationDto[];
  /** Suggested cash Asset Chart of Account ID, when deterministically known. */
  chartOfAccountId?: string;
  /** Optional suggested settlement memo. */
  memo?: string;
}) & {
  type: 'settling';
};

/** StartManualReconciliationDto */
export interface StartManualReconciliationDto {
  /** @format date */
  asOf: string;
  /** @format double */
  opening?: number;
  /** @format double */
  additions: number;
  /** @format double */
  subtractions: number;
  memo?: string;
}

/** SubmitManualJournalEntryRequestDto */
export interface SubmitManualJournalEntryRequestDto {
  /** @minLength 1 */
  submittedById: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  reason?: string;
}

/** SummaryDto */
export interface SummaryDto {
  /** @format double */
  beginningCashBalance: number;
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
  /** @format double */
  ownerContributions: number;
  /** @format double */
  ownerDistributions: number;
  /** @format double */
  endingCashBalance: number;
  /** @format double */
  unpaidBills: number;
  /** @format double */
  amountToPayOut: number;
  /** @format double */
  propertyReserve: number;
  /** @format double */
  netOwnerFunds: number;
}

/** TransactionAllocationDto */
export interface TransactionAllocationDto {
  billId: string;
  billType: BillType;
  /** @format double */
  amount: number;
}

/** TransactionDto */
export interface TransactionDto {
  id: string;
  identity: TransactionIdentity;
  type: TransactionType;
  direction: TransactionDirection;
  status: TransactionStatus;
  paymentMethod: TransactionPaymentMethod;
  /** @format double */
  amount: number;
  /** @format date */
  transactionDate: string;
  /** @format date */
  finalizedDate?: string;
  memo?: string;
  reference?: string;
  bankAccountId: string;
  chartOfAccountId: string;
  portfolioId?: string;
  propertyId?: string;
  propertyName?: string;
  unitId?: string;
  leaseId?: string;
  leaseName?: string;
  tenantId?: string;
  tenantName?: string;
  ownerId?: string;
  ownerName?: string;
  vendorId?: string;
  vendorName?: string;
  subsidizerId?: string;
  rentalApplicationId?: string;
  checkId?: string;
  linkedTransactionId?: string;
  bankLedgerTransferId?: string;
  allocations: TransactionAllocationDto[];
}

/** TransactionEntryDto */
export interface TransactionEntryDto {
  /** @format date-time */
  date: string;
  partyInfo: PartyInfoDto;
  description: string;
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
  /** @format double */
  runningBalance: number;
  sourceId: string;
  sourceType: JournalEntrySourceType;
  entityType: JournalEntryType;
}

/** UnpaidBillDto */
export interface UnpaidBillDto {
  id: string;
  /** @format date-time */
  dueDate: string;
  description: string;
  /** @format double */
  amount: number;
  entityType: JournalEntryType;
}

/** UpdateBankAccountRequestDto */
export interface UpdateBankAccountRequestDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  accountNumber?: string;
  /**
   * @minLength 0
   * @maxLength 20
   */
  routingNumber?: string;
  type?: BankAccountType;
  scheduledSweepDays?: number[];
  /** @minItems 1 */
  chartOfAccountIds?: string[];
}

/** UpdateChartOfAccountRequestDto */
export interface UpdateChartOfAccountRequestDto {
  parentId?: string;
  /**
   * @format int32
   * @min 100000
   * @max 899999
   */
  number?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name?: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  description?: string;
}

/** UpdateDepositSlipDto */
export interface UpdateDepositSlipDto {
  /** @format date */
  deposited: string;
}

/** UpdateManualJournalEntryRequestDto */
export interface UpdateManualJournalEntryRequestDto {
  companyBill?: boolean;
  /** @format date-time */
  postingDate?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  status?: ManualJournalEntryStatus;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  rejectionReason?: string;
  /** @minItems 2 */
  lines?: UpdateManualJournalLineRequestDto[];
}

/** UpdateManualJournalLineRequestDto */
export interface UpdateManualJournalLineRequestDto {
  id?: string;
  /** @minLength 1 */
  chartOfAccountId: string;
  bankAccountId?: string;
  /**
   * @format double
   * @min 0.01
   * @max 999999999.99
   */
  amount: number;
  isDebit: boolean;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  order: number;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  ownerId?: string;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  tenantId?: string;
  vendorId?: string;
}

/** UpdateManualReconciliationDto */
export interface UpdateManualReconciliationDto {
  /** @format date */
  asOf?: string;
  /** @format double */
  additions?: number;
  /** @format double */
  subtractions?: number;
  memo?: string;
}

/** UpdateReconciliationPeriodDto */
export interface UpdateReconciliationPeriodDto {
  /** @format date */
  periodStart?: string;
  /** @format date */
  periodEnd?: string;
  /** @format double */
  openingBalance?: number;
  /** @format double */
  closingBalance?: number;
}

/** UpdateVendorBillLineItemDto */
export interface UpdateVendorBillLineItemDto {
  id?: string;
  chartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /** @format double */
  amount: number;
}

/** UpdateVendorBillRequestDto */
export interface UpdateVendorBillRequestDto {
  companyBill?: boolean;
  /** @format date */
  billDate?: string;
  /** @format date */
  dueDate?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  reference?: string;
  vendorId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  /** @minItems 1 */
  lineItems?: UpdateVendorBillLineItemDto[];
  adjustPayments: boolean;
}

/** UploadSessionDto */
export interface UploadSessionDto {
  sessionId: string;
  endpoint: string;
  method: string;
  fields: Record<string, string>;
  /** @format date-time */
  expires: string;
}

/** VendorBillAllocationDto */
export interface VendorBillAllocationDto {
  id?: string;
  transactionId: string;
  /** @format double */
  amount: number;
  /** @format date-time */
  applied: string;
  /** @format date-time */
  voided?: string;
  voidReason?: string;
}

/** VendorBillDto */
export interface VendorBillDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  companyBill: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  memo?: string;
  reference?: string;
  sourceType?: VendorBillSourceType;
  sourceId?: string;
  vendorId: string;
  status: VendorBillStatus;
  assignedToId?: string;
  assignedById?: string;
  /** @format date-time */
  assignedAt?: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
  lineItems: VendorBillLineItemDto[];
  files: VendorBillFileDto[];
  creator: CreatorDto;
}

/** VendorBillFileDto */
export interface VendorBillFileDto {
  fileId: string;
  description?: string;
}

/** VendorBillFileRequestDto */
export interface VendorBillFileRequestDto {
  fileId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** VendorBillFilesRequestDto */
export interface VendorBillFilesRequestDto {
  /** @minItems 1 */
  files: VendorBillFileRequestDto[];
}

/** VendorBillLineItemDto */
export interface VendorBillLineItemDto {
  id?: string;
  /** @format int32 */
  order: number;
  chartOfAccountId: string;
  chartOfAccountName?: string;
  portfolioId?: string;
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
  description?: string;
  /** @format double */
  amount: number;
  allocations: VendorBillAllocationDto[];
  /** @format double */
  allocatedAmount: number;
  /** @format double */
  dueAmount: number;
}

/** VendorBillPaginationDto */
export interface VendorBillPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: VendorBillDto[];
}

/** ResolveReconciliationItemRequestDto */
interface BaseResolveReconciliationItemRequestDto {
  type: 'accept' | 'ignore' | 'match' | 'post' | 'settle';
}

type BaseResolveReconciliationItemRequestDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

/** ReconciliationCandidatePayloadDto */
interface BaseReconciliationCandidatePayloadDto {
  type: 'bankLedgerTransfer' | 'leaseCharge' | 'leaseDeposit' | 'ownerContribution' | 'ownerDistribution';
}

type BaseReconciliationCandidatePayloadDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

/** ReconciliationCandidateDto */
interface BaseReconciliationCandidateDto {
  type: 'matching' | 'posting' | 'settling';
  /** Candidate ID. */
  id: string;
  /** Whether this Candidate is structurally complete and can be accepted exactly. */
  canAccept: boolean;
}

type BaseReconciliationCandidateDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

export interface GetBankAccountParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface PatchBankAccountParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface DeleteBankAccountParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface ActivateBankAccountParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface DeactivateBankAccountParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface GetBankLedgerTransfersParams {
  /** @format date */
  'transferDate.start'?: string;
  /** @format date */
  'transferDate.end'?: string;
  'transferDate.startInclusive'?: boolean;
  'transferDate.endInclusive'?: boolean;
  /** @minItems 1 */
  transferTypes?: BankLedgerTransferType[];
  /**
   * @minLength 1
   * @maxLength 1000
   */
  memo?: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  reference?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
}

export interface GetBankLedgerTransferParams {
  /** @format int64 */
  bankLedgerTransferId: string;
}

export interface PatchBankLedgerTransferParams {
  /** @format int64 */
  bankLedgerTransferId: string;
}

export interface DeleteBankLedgerTransferParams {
  /** @format int64 */
  bankLedgerTransferId: string;
}

export interface GetChartOfAccountParams {
  /** @format int64 */
  chartOfAccountId: string;
}

export interface PatchChartOfAccountParams {
  /** @format int64 */
  chartOfAccountId: string;
}

export interface DeleteChartOfAccountParams {
  /** @format int64 */
  chartOfAccountId: string;
}

export interface CreateUpdateLinkTokenParams {
  /** @format int64 */
  connectionId: string;
}

export interface CompleteReauthenticationParams {
  /** @format int64 */
  connectionId: string;
}

export interface GetConnectionParams {
  /** @format int64 */
  connectionId: string;
}

export interface RemoveConnectionParams {
  /** @format int64 */
  connectionId: string;
}

export interface RequestRefreshParams {
  /** @format int64 */
  connectionId: string;
}

export interface GetDepositSlipSummariesParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int64 */
  bankAccountId?: string;
  /** @format date */
  'deposited.start'?: string;
  /** @format date */
  'deposited.end'?: string;
  'deposited.startInclusive'?: boolean;
  'deposited.endInclusive'?: boolean;
}

export interface GetDepositSlipDetailParams {
  /** @format int64 */
  depositSlipId: string;
}

export interface UpdateDepositSlipParams {
  /** @format int64 */
  depositSlipId: string;
}

export interface DeleteDepositSlipParams {
  /** @format int64 */
  depositSlipId: string;
}

export interface GetDepositSlipCandidatesParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  bankAccountId: string;
  /** @format date */
  'transactionDate.start'?: string;
  /** @format date */
  'transactionDate.end'?: string;
  'transactionDate.startInclusive'?: boolean;
  'transactionDate.endInclusive'?: boolean;
  /** @format date */
  'finalizedDate.start'?: string;
  /** @format date */
  'finalizedDate.end'?: string;
  'finalizedDate.startInclusive'?: boolean;
  'finalizedDate.endInclusive'?: boolean;
}

export interface ListParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface StartParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface LastParams {
  /** @format int64 */
  bankAccountId: string;
}

export interface DetailParams {
  /** @format int64 */
  bankAccountId: string;
  /** @format int64 */
  manualReconciliationId: string;
}

export interface UpdateParams {
  /** @format int64 */
  bankAccountId: string;
  /** @format int64 */
  manualReconciliationId: string;
}

export interface DeleteParams {
  /** @format int64 */
  bankAccountId: string;
  /** @format int64 */
  manualReconciliationId: string;
}

export interface CandidatesParams {
  showAll?: boolean;
  /** @format int64 */
  bankAccountId: string;
  /** @format int64 */
  manualReconciliationId: string;
}

export interface AddEntriesParams {
  /** @format int64 */
  bankAccountId: string;
  /** @format int64 */
  manualReconciliationId: string;
}

export interface RemoveEntriesParams {
  /** @format int64 */
  bankAccountId: string;
  /** @format int64 */
  manualReconciliationId: string;
}

export interface CompleteParams {
  /** @format int64 */
  bankAccountId: string;
  /** @format int64 */
  manualReconciliationId: string;
}

export interface CancelParams {
  /** @format int64 */
  bankAccountId: string;
  /** @format int64 */
  manualReconciliationId: string;
}

export interface GetSummaryParams {
  /** @format int64 */
  bankAccountId?: string;
}

export interface GetItemsParams {
  /** @format int64 */
  bankAccountId?: string;
  statuses?: ReconciliationItemStatus[];
  resolutionTypes?: ReconciliationResolutionType[];
  reviewReasons?: ReconciliationReviewReason[];
  /** @format date */
  'occurred.start'?: string;
  /** @format date */
  'occurred.end'?: string;
  'occurred.startInclusive'?: boolean;
  'occurred.endInclusive'?: boolean;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
}

export interface GetItemParams {
  /** @format int64 */
  reconciliationItemId: string;
}

export interface ResolveItemParams {
  /** @format int64 */
  reconciliationItemId: string;
}

export interface AcknowledgeReviewParams {
  /** @format int64 */
  reconciliationItemId: string;
}

export interface RematchItemParams {
  /** @format int64 */
  reconciliationItemId: string;
}

export interface GenerateCandidatesParams {
  /** @format int64 */
  reconciliationItemId: string;
}

export interface GetMatchTargetsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /**
   * @minLength 2
   * @maxLength 500
   */
  search?: string;
  /**
   * @format int32
   * @min 1
   * @max 90
   */
  nearbyDays?: number;
  /** @format int64 */
  reconciliationItemId: string;
}

export interface GetSettleTargetsParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** Settle target identity. Supported values: VendorBill. */
  identity: TransactionIdentity;
  /** @format int64 */
  vendorId?: string;
  /**
   * @minLength 2
   * @maxLength 500
   */
  search?: string;
  /** @format int64 */
  reconciliationItemId: string;
}

export interface GetPeriodsParams {
  bankAccountId: string;
}

export interface GetPeriodParams {
  /** @format int64 */
  reconciliationPeriodId: string;
}

export interface UpdatePeriodParams {
  /** @format int64 */
  reconciliationPeriodId: string;
}

export interface DeletePeriodParams {
  /** @format int64 */
  reconciliationPeriodId: string;
}

export interface GetPeriodItemsParams {
  status?: ReconciliationItemStatus;
  resolutionType?: ReconciliationResolutionType;
  hasReview?: boolean;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
  /** @format int64 */
  reconciliationPeriodId: string;
}

export interface LockPeriodParams {
  /** @format int64 */
  reconciliationPeriodId: string;
}

export interface ReopenPeriodParams {
  /** @format int64 */
  reconciliationPeriodId: string;
}

export interface AcknowledgeDispositionParams {
  /** @format int64 */
  reconciliationPeriodId: string;
  /** @format int64 */
  dispositionId: string;
}

export interface GetOnlinePaymentsSummaryParams {
  /** @default false */
  skipCache?: boolean;
}

export interface GetOnTimeRentPaymentSummaryParams {
  /** @default false */
  skipCache?: boolean;
}

export interface GetDailyMoneyMovementParams {
  /** @default false */
  skipCache?: boolean;
}

export interface GetReturnsAndDisputesParams {
  /** @default false */
  skipCache?: boolean;
}

export interface GetManualJournalEntriesParams {
  /** @format date */
  'postingDate.start'?: string;
  /** @format date */
  'postingDate.end'?: string;
  'postingDate.startInclusive'?: boolean;
  'postingDate.endInclusive'?: boolean;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
  /** @minItems 1 */
  statuses?: ManualJournalEntryStatus[];
  /** @minItems 1 */
  createdByUserIds?: string[];
  /** @minItems 1 */
  submittedByUserIds?: string[];
  /** @minItems 1 */
  approvedByUserIds?: string[];
  /** @minItems 1 */
  postedByUserIds?: string[];
  /** @minItems 1 */
  rejectedByUserIds?: string[];
  /** @format date */
  'submittedAt.start'?: string;
  /** @format date */
  'submittedAt.end'?: string;
  'submittedAt.startInclusive'?: boolean;
  'submittedAt.endInclusive'?: boolean;
  /** @format date */
  'approvedAt.start'?: string;
  /** @format date */
  'approvedAt.end'?: string;
  'approvedAt.startInclusive'?: boolean;
  'approvedAt.endInclusive'?: boolean;
  /** @format date */
  'postedAt.start'?: string;
  /** @format date */
  'postedAt.end'?: string;
  'postedAt.startInclusive'?: boolean;
  'postedAt.endInclusive'?: boolean;
  /** @format date */
  'rejectedAt.start'?: string;
  /** @format date */
  'rejectedAt.end'?: string;
  'rejectedAt.startInclusive'?: boolean;
  'rejectedAt.endInclusive'?: boolean;
  /** @minItems 1 */
  chartOfAccountIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  unitIds?: string[];
  /** @minItems 1 */
  leaseIds?: string[];
  /** @minItems 1 */
  tenantIds?: string[];
  /** @minItems 1 */
  vendorIds?: string[];
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
}

export interface GetManualJournalEntryParams {
  /** @format int64 */
  manualJournalEntryId: string;
}

export interface PatchManualJournalEntryParams {
  /** @format int64 */
  manualJournalEntryId: string;
}

export interface DeleteManualJournalEntryParams {
  /** @format int64 */
  manualJournalEntryId: string;
}

export interface SubmitManualJournalEntryParams {
  /** @format int64 */
  manualJournalEntryId: string;
}

export interface ApproveManualJournalEntryParams {
  /** @format int64 */
  manualJournalEntryId: string;
}

export interface RejectManualJournalEntryParams {
  /** @format int64 */
  manualJournalEntryId: string;
}

export interface PostManualJournalEntryParams {
  /** @format int64 */
  manualJournalEntryId: string;
}

export interface CreateBalanceSheetParams {
  /** The accounting basis for the report Cash/Accrual. */
  basis: AccountingBasis;
  /** The report type Company/Property. */
  reportType: ReportType;
  /** List of property IDs for which the report is generated. */
  portfolioIds?: string[];
  /** List of property IDs for which the report is generated. */
  propertyIds?: string[];
  /**
   * The date as of which the report is generated.
   * @format date
   */
  asOfDate?: string;
}

export interface CreateIncomeStatementParams {
  /** The accounting basis for the report Cash/Accrual. */
  basis: AccountingBasis;
  /** The report type Company/Property. */
  reportType: ReportType;
  /** List of property IDs for which the report is generated. */
  portfolioIds?: string[];
  /** List of property IDs for which the report is generated. */
  propertyIds?: string[];
  /**
   * The start date of the income statement period.
   * @format date
   */
  startDate: string;
  /**
   * The end date of the income statement period.
   * @format date
   */
  endDate: string;
}

export interface CreateGeneralLedgerParams {
  /** The accounting basis for the report Cash/Accrual. */
  basis: AccountingBasis;
  /** The report type Company/Property. */
  reportType: ReportType;
  /** List of property IDs for which the report is generated. */
  portfolioIds?: string[];
  /** List of property IDs for which the report is generated. */
  propertyIds?: string[];
  /**
   * The start date of the general ledger period.
   * @format date
   */
  startDate: string;
  /**
   * The end date of the general ledger period.
   * @format date
   */
  endDate: string;
  /** The list of accounts for which the ledger is requested. */
  coaIds?: string[];
}

export interface CreateMasterLedgerParams {
  /** The accounting basis for the report Cash/Accrual. */
  basis: AccountingBasis;
  /** The report type Company/Property. */
  reportType: ReportType;
  /** List of property IDs for which the report is generated. */
  portfolioIds?: string[];
  /** List of property IDs for which the report is generated. */
  propertyIds?: string[];
  /**
   * The start date of the general ledger period.
   * @format date
   */
  startDate: string;
  /**
   * The end date of the general ledger period.
   * @format date
   */
  endDate: string;
  /** The list of accounts for which the ledger is requested. */
  coaIds?: string[];
}

export interface CreateCashFlowStatementParams {
  /** The report type Company/Property. */
  reportType: ReportType;
  /** Grouping for the cash flow statement: Total, Property, Year, Quarter, Month. */
  groupBy: CashFlowGroupBy;
  /** List of portfolio IDs to filter by. */
  portfolioIds?: string[];
  /** List of property IDs to filter by. */
  propertyIds?: string[];
  /**
   * The start date of the cash flow statement period.
   * @format date
   */
  startDate: string;
  /**
   * The end date of the cash flow statement period.
   * @format date
   */
  endDate: string;
}

export interface CreateRentPaymentsReportParams {
  /** List of portfolio IDs to filter by. */
  portfolioIds?: string[];
  /** List of property IDs to filter by. */
  propertyIds?: string[];
  /** @format date */
  'dateRange.start'?: string;
  /** @format date */
  'dateRange.end'?: string;
  'dateRange.startInclusive'?: boolean;
  'dateRange.endInclusive'?: boolean;
  /** Filter by external transaction type (e.g., Offline for offline payments, Plaid/Stripe/MagicDoor/Zelle for online). */
  externalTransactionTypes?: ExternalTransactionType[];
  /** Filter by payment method (ACH, CreditCard, Cash, Check, Zelle, etc.). */
  paymentMethods?: TransactionPaymentMethod[];
  /** Filter by transaction status (Pending, Success, Failed, Returned, Refunded, etc.). */
  statuses?: TransactionStatus[];
  /** Filter by transaction identity (LeaseCharge, LeaseDeposit, LeaseProcessingFee). Defaults to all lease-related identities. */
  identities?: TransactionIdentity[];
}

export interface CreateOwnerStatementParams {
  /** @format int64 */
  ownerId?: string;
  withUnpaidBills?: boolean;
  portfolioIds?: string[];
  propertyIds?: string[];
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
}

export interface GetOwnerPackagesParams {
  ownerIds?: string[];
  /** @format date-time */
  createdAfter?: string;
  /** @format date-time */
  createdBefore?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  'pagination.page'?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  'pagination.pageSize'?: number;
}

export interface GetOwnerPackageParams {
  /** @format int64 */
  id: string;
}

export interface DeleteOwnerPackageParams {
  /** @format int64 */
  id: string;
}

export interface GetTransactionParams {
  /** @format int64 */
  transactionId: string;
}

export interface GetVendorBillsParams {
  companyBill?: boolean;
  /** @minItems 1 */
  vendorIds?: string[];
  /** @minItems 1 */
  portfolioIds?: string[];
  /** @minItems 1 */
  propertyIds?: string[];
  /** @minItems 1 */
  unitIds?: string[];
  /** @minItems 1 */
  leaseIds?: string[];
  /** @minItems 1 */
  ownerIds?: string[];
  /** @minItems 1 */
  statuses?: VendorBillStatus[];
  /** @minItems 1 */
  assignedToIds?: string[];
  /** @minItems 1 */
  assignedByIds?: string[];
  /** @format date-time */
  'assignedAt.start'?: string;
  /** @format date-time */
  'assignedAt.end'?: string;
  'assignedAt.startInclusive'?: boolean;
  'assignedAt.endInclusive'?: boolean;
  /** @format date */
  'billDate.start'?: string;
  /** @format date */
  'billDate.end'?: string;
  'billDate.startInclusive'?: boolean;
  'billDate.endInclusive'?: boolean;
  /** @format date */
  'dueDate.start'?: string;
  /** @format date */
  'dueDate.end'?: string;
  'dueDate.startInclusive'?: boolean;
  'dueDate.endInclusive'?: boolean;
  /** @format double */
  'totalAmount.start'?: number;
  /** @format double */
  'totalAmount.end'?: number;
  'totalAmount.startInclusive'?: boolean;
  'totalAmount.endInclusive'?: boolean;
  /** @format double */
  'dueAmount.start'?: number;
  /** @format double */
  'dueAmount.end'?: number;
  'dueAmount.startInclusive'?: boolean;
  'dueAmount.endInclusive'?: boolean;
  hasInvoices?: boolean;
  /** @minItems 1 */
  magicTagValues?: string[];
  /**
   * @minLength 1
   * @maxLength 150
   */
  search?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize?: number;
}

export interface GetVendorBillParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface UpdateVendorBillParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface DeleteVendorBillParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface SetVendorBillSourceParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface DeleteVendorBillPaymentParams {
  /** @format int64 */
  vendorBillId: string;
  /** @format int64 */
  transactionId: string;
}

export interface RequestVendorBillFileUploadSessionParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface AddVendorBillFilesParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface UpdateVendorBillFilesParams {
  /** @format int64 */
  vendorBillId: string;
}

export interface DeleteVendorBillFilesParams {
  /** @format int64 */
  vendorBillId: string;
}
